import { render, staticRenderFns } from "./CompetencesProfessionnelles.vue?vue&type=template&id=4aace1ed&"
import script from "./CompetencesProfessionnelles.vue?vue&type=script&lang=js&"
export * from "./CompetencesProfessionnelles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports